module.exports = __webpack_public_path__ + "static/redhat_smallBanner-233c73e0c8e0b0cc57c1832900ad5827.png";